/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  CoreLoginOktaLoginTypeParams,
  CoreLoginCaptchaLoginTypeParams,
  LoginRequest,
  RefreshTokenRequest,
  RegistrationCodeRequest,
  ForwardRegistrationRequest,
  RequestPasswordResetRequest,
  AuthorizedRequestPasswordResetRequest,
  MfaRequest,
  ResetPasswordRequest,
  UpdateSessionRequest2,
  UpgradeOktaTokenRequest,
  CaptchaRequest,
  MultiFactorResetRequest,
  UserResponse,
  LoginResponse,
  SsoTokenResponse,
  TokenResponse,
  RefreshTokenResponse,
  RegistrationCodeResponse,
  SuccessResponse,
  AuthorizedRequestPasswordResetResponse,
  TokenExpirationResponse,
  OktaLoginTypeResponse,
  CaptchaTypeResponse,
  MultiFactorResetResponse
 } from '../types';

  //  CoreLoginClient
class CoreLoginClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly currentUser = (): AxiosPromise<UserResponse> => {
        let url_ = "/api/v1/core/current_user";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly login = (payload: LoginRequest): AxiosPromise<LoginResponse> => {
        let url_ = "/api/v1/core/login";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly generateSSOToken = (): AxiosPromise<SsoTokenResponse> => {
        let url_ = "/api/v1/core/login/sso_token";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly newToken = (): AxiosPromise<TokenResponse> => {
        let url_ = "/api/v1/core/new_token";

        const sendRequestPayload: SendRequestPayload = {
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly newRefreshToken = (payload: RefreshTokenRequest): AxiosPromise<RefreshTokenResponse> => {
        let url_ = "/api/v1/core/new_refresh_token";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly registrationCode = (payload: RegistrationCodeRequest): AxiosPromise<RegistrationCodeResponse> => {
        let url_ = "/api/v1/core/registration_code";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly forwardRegistration = (payload: ForwardRegistrationRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/forward_registration";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly logout = (): AxiosPromise<void> => {
        let url_ = "/api/v1/core/logout";

        const sendRequestPayload: SendRequestPayload = {
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly requestPasswordReset = (payload: RequestPasswordResetRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/request_password_reset";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly requestAuthorizedPasswordReset = (payload: AuthorizedRequestPasswordResetRequest): AxiosPromise<AuthorizedRequestPasswordResetResponse> => {
        let url_ = "/api/v1/core/request_authorized_password_reset";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly requestMfaCode = (payload: MfaRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/request_mfa_code";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly resetPassword = (payload: ResetPasswordRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/reset_password";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly updateSession = (payload: UpdateSessionRequest2): AxiosPromise<LoginResponse> => {
        let url_ = "/api/v1/core/session";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    /**
     * Returns the number of seconds until the JWT_COOKIE expires
    If this route changes, update the reference in CustomCookieAuthenticationEvents specifically to prevent cookie refreshing
     */
    readonly tokenExpiration = (): AxiosPromise<TokenExpirationResponse> => {
        let url_ = "/api/v1/core/token_expiration";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly heartbeat = (): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/heartbeat";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly ping = (): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/ping";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly oktaLoginType = (queryParams: CoreLoginOktaLoginTypeParams): AxiosPromise<OktaLoginTypeResponse> => {
        let url_ = "/api/v1/core/login/okta_type";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly upgradeOktaToken = (payload: UpgradeOktaTokenRequest): AxiosPromise<LoginResponse> => {
        let url_ = "/api/v1/core/login/upgrade_okta_token";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly captchaLoginType = (queryParams: CoreLoginCaptchaLoginTypeParams): AxiosPromise<CaptchaTypeResponse> => {
        let url_ = "/api/v1/core/login/captcha_type";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly resetCaptcha = (payload: CaptchaRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/login/reset_captcha";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly requestMultiFactorReset = (payload: MultiFactorResetRequest): AxiosPromise<MultiFactorResetResponse> => {
        let url_ = "/api/v1/core/login/request_mfa_reset";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CoreLoginClient
  
export const coreLoginClient = new CoreLoginClient(baseClientConstructorProps);
